import React from "react";
import styles from "./styles.module.scss";
import spareImg from "../../../shared/images/spare.svg";
import { useStoreon } from "storeon/react";

const TopLowFrame = (props) => {
  const { players, showLow, title } = props;
  const { tableSettings, loggedInUserProfile } = useStoreon(
    "tableSettings",
    "loggedInUserProfile"
  );
  const { accountType } = loggedInUserProfile;
  const loggedInUser = localStorage.getItem("loggedInUser");
  const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);
  const squares = new Array(12).fill("");

  const isSplit = (pin) => {
    return Math.floor(pin / 1024) === 1;
  };

  const someStyle = {
    "--evenBackground": tableSettings.evenRows.background,
    "--evenColor": tableSettings.evenRows.color,
    "--evenFontSize": tableSettings.evenRows.fontSize,
    "--evenFontWeight": tableSettings.evenRows.fontWeight,
    "--oddBackground": tableSettings.oddRows.background,
    "--oddColor": tableSettings.oddRows.color,
    "--oddFontSize": tableSettings.oddRows.fontSize,
    "--oddFontWeight": tableSettings.oddRows.fontWeight,
    "--scoreBackground": tableSettings.maxScore.background,
    "--scoreColor": tableSettings.maxScore.color,
    "--scoreFontSize": tableSettings.maxScore.fontSize,
    "--scoreFontWeight": tableSettings.maxScore.fontWeight
      ? tableSettings.maxScore.fontWeight
      : loggedInUserObj.accountType === "Freemium"
      ? "400"
      : "normal",
    "--frameContainerBackground": tableSettings.frameContainer.background,
    "--frameContainerColor": tableSettings.frameContainer.color,
    "--frameContainerFontSize": tableSettings.frameContainer.fontSize,
    "--frameContainerFontWeight":
      loggedInUserObj.accountType === "Freemium"
        ? "600"
        : tableSettings.frameContainer.fontWeight
        ? tableSettings.frameContainer.fontWeight
        : "600",
    "--sectionContainerBackground": tableSettings.sectionContainerBackground,
    "--fontFamily":
      loggedInUserObj.accountType === "Freemium"
        ? "Roboto Mono"
        : "'Saira', sans-serif",
    "--turnFontWeight": "600",
  };

  return (
    <div className={styles.containerTable} style={someStyle}>
      <div className={styles.title}>{title}</div>
      {players && players.length ? (
        <div className={styles.playersCard}>
          <div className={styles.bodyTable}>
            <div className={styles.turns} style={someStyle}>
              {squares.slice(0, 10).map((e, index) => (
                <span className={styles.turn} key={index}>
                  {index + 1}
                </span>
              ))}
              <span className={styles.turn}>Max Score</span>
            </div>
            {players.map((laneThrow, index) => {
              return (
                <div className={styles.players} key={index}>
                  <div className={styles.squares}>
                    <span
                      className={styles.playerName}
                      style={{
                        lineHeight: showLow ? "50px" : "",
                      }}
                    >
                      {laneThrow.playerName}
                    </span>
                    {squares.map((e, index) => (
                      <span
                        className={`${styles.square} ${
                          laneThrow.throws &&
                          laneThrow.throws.length > index * 2 &&
                          styles.past
                        }`}
                        key={index}
                      >
                        {(laneThrow.throws &&
                          laneThrow.throws.length &&
                          laneThrow.throws[index * 2] &&
                          laneThrow.throws[index * 2] !== "X" &&
                          index < 9 && (
                            <span className={styles.numbers}>
                              <span
                                className={`${styles.number} ${
                                  isSplit(laneThrow.pins[index * 2]) &&
                                  styles.split
                                }`}
                              >
                                {laneThrow.throws[index * 2]}
                              </span>
                              {laneThrow.throws[index * 2 + 1] !== "/" && (
                                <span
                                  className={`${styles.number} ${
                                    isSplit(laneThrow.pins[index * 2 + 1]) &&
                                    styles.split
                                  }`}
                                >
                                  {laneThrow.throws[index * 2 + 1]}
                                </span>
                              )}
                              {laneThrow.throws[index * 2 + 1] === "/" && (
                                <span className={styles.number}>
                                  <img src={spareImg} alt="" />
                                </span>
                              )}
                            </span>
                          )) ||
                          ""}
                        {(index > 8 && (
                          <div>
                            {laneThrow.throws &&
                              laneThrow.throws[index * 2] !== "/" &&
                              laneThrow.throws[index * 2] !== "X" && (
                                <span
                                  className={`${styles.number} ${
                                    styles.fixTop
                                  } ${
                                    isSplit(laneThrow.pins[index * 2]) &&
                                    styles.split
                                  }`}
                                >
                                  {laneThrow.throws[index * 2]}
                                </span>
                              )}
                            {laneThrow.throws &&
                              laneThrow.throws[index * 2] === "/" &&
                              laneThrow.throws[index * 2] !== "X" && (
                                <span className={`${styles.number}`}>
                                  <img src={spareImg} alt="" />
                                </span>
                              )}
                          </div>
                        )) ||
                          ""}
                        {(laneThrow.throws &&
                          laneThrow.throws.length &&
                          laneThrow.throws[index * 2] &&
                          laneThrow.throws[index * 2] === "X" && (
                            <span className={styles.strike}>X</span>
                          )) ||
                          ""}
                        {(index < 9 &&
                          laneThrow.throws &&
                          (!laneThrow.throws.length ||
                            !laneThrow.throws[index * 2]) && (
                            <span className={styles.numbers}>
                              <span className={styles.number}></span>
                              <span className={styles.number}></span>
                            </span>
                          )) ||
                          ""}
                        {(index > 9 &&
                          laneThrow.throws &&
                          (!laneThrow.throws.length ||
                            !laneThrow.throws[index * 2]) && (
                            <div className={styles.numbers}>
                              <span
                                className={`${styles.number} ${
                                  isSplit(laneThrow.pins[index * 2]) &&
                                  styles.split
                                }`}
                              ></span>
                            </div>
                          )) ||
                          ""}
                      </span>
                    ))}
                    <span className={styles.square} style={someStyle}>
                      {!props.showLow && laneThrow.maxScore}
                    </span>
                  </div>

                  {showLow && (
                    <div className={styles.squares}>
                      <span className={styles.playerName}></span>
                      {squares.slice(0, 10).map((e, index) => {
                        return (
                          <span
                            className={`${styles.square} ${styles.score} ${
                              laneThrow &&
                              laneThrow.throws.length > index * 2 &&
                              styles.past
                            }`}
                            key={index}
                          >
                            <span className={styles.numbers}>
                              <span className={styles.scoreNumber}>
                                {(laneThrow && laneThrow.scores[index]) || ""}
                              </span>
                            </span>
                          </span>
                        );
                      })}
                      <div
                        className={styles.square}
                        data-content={laneThrow.maxScore}
                        style={someStyle}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div>There are no players</div>
      )}
    </div>
  );
};

export default TopLowFrame;
